<template>
    <div class="flex flex-col items-center justify-center w-full ">
        <component
            ref="offers"
            v-for="(offer, index) in offers"
            :key="index"
            :is="offer.model"
            :data="offer.object"
            v-on:remove="removeOffer($event, index)"
        />
        <base-add-button
            title="Ajouter un Produit / Service"
            @click="addOffer"
        />
        <base-primary-button title="Suivant" @click="nextStep" />
    </div>
</template>

<script>
import productCard from "./components/productCard";
import { mapState } from "vuex";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        productCard
    },
    data() {
        return {
            offers: []
        };
    },
    mixins: [scrollToError],
    mounted() {
        this.offers = this.$store.getters["VotreProject/getOffers"];
        this.$store.dispatch("forms/currentStepVotreProject", "Votre Offres");
    },

    methods: {
        addOffer() {
            if (!this.checkForms()) {
                this.offers.push({
                    model: "product-card",
                    key: new Date().getTime(),
                    object: {
                        id: new Date().getTime(),
                        name: "",
                        description: "",
                        type: "product"
                    }
                });
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        removeOffer(payload, index) {
            this.$store.dispatch("VotreProject/removeOffer", payload);
            this.offers.splice(index, 1);
        },
        nextStep() {
            if (!this.checkForms() && this.offerLength >= 1) {
                this.$store.dispatch("VotreProject/SaveOffers");
                this.$store.dispatch("forms/completStep", "Vos Offres");
                this.$router.push({
                    name: "vos_clients",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.offers.forEach(offer => {
                if (!offer.createOffer()) {
                    formsHasError = true;
                }
            });
            return formsHasError;
        }
    },
    computed: {
        ...mapState("VotreProject", {
            offerLength: state => state.offers.length
        })
    }
};
</script>

<style></style>
